import { render, staticRenderFns } from "./ProyekIcon.vue?vue&type=template&id=1fec88ab"
import script from "./ProyekIcon.vue?vue&type=script&lang=js"
export * from "./ProyekIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports